// import nodeAccountList from '../components/nodeAccount/nodeAccountList.vue'

export default [
    { 
        path: 'nodeAccount/nodeAccountList', //报修
        component: resolve => require(['@/components/nodeAccount/nodeAccountList'],resolve),
        name:'NodeAccountList',
        meta:{
            // id:'399',
            node:'nodeAccount',
            url:'nodeAccountList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/nodeAccount.js